/* Afternoon Table — theme runtime
   header scroll · scroll reveal · mobile nav · cart drawer (AJAX) ·
   product form (variant + qty + add-to-cart) · gallery · shop filter */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (cents) {
    try { return '$' + (cents / 100).toFixed(2); } catch (e) { return ''; }
  };

  /* ---------- header scroll ---------- */
  var hdr = $('[data-header]');
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- scroll reveal ---------- */
  (function () {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0, rootMargin: '0px 0px -7% 0px' });
    els.forEach(function (el) {
      if (el.getBoundingClientRect().top < (window.innerHeight || 800) * 0.92) { el.classList.add('in'); }
      else { io.observe(el); }
    });
  })();

  /* ---------- mobile nav ---------- */
  (function () {
    var nav = $('[data-mnav]');
    if (!nav) return;
    var open = function () { nav.classList.add('open'); document.body.style.overflow = 'hidden'; };
    var close = function () { nav.classList.remove('open'); document.body.style.overflow = ''; };
    $$('[data-mnav-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', close); });
  })();

  /* ---------- toast ---------- */
  var toastEl = $('#ToastCart');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg || 'Added to cart';
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  function openCart() { if (drawer) { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; } }
  function closeCart() { if (drawer) { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; } }
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-close]')) closeCart();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); } });

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); } else { el.setAttribute('hidden', ''); }
    });
  }

  function rerenderCart(sectionsHtml) {
    var body = $('[data-cart-body]');
    if (sectionsHtml && sectionsHtml['cart-drawer'] && body) {
      var doc = new DOMParser().parseFromString(sectionsHtml['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('[data-cart-body]');
      if (fresh) { body.innerHTML = fresh.innerHTML; bindCartLineEvents(); }
    } else {
      // fallback: reload cart section
      fetch('/?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-body]');
        if (fresh && body) { body.innerHTML = fresh.innerHTML; bindCartLineEvents(); }
      });
    }
  }

  function refreshCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCount(c.item_count); });
  }

  function postCart(url, data) {
    data.sections = 'cart-drawer';
    data.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function changeLine(key, qty) {
    postCart('/cart/change.js', { id: key, quantity: qty }).then(function (res) {
      updateCartCount(res.item_count);
      rerenderCart(res.sections);
    });
  }

  function bindCartLineEvents() {
    $$('.cart-line').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qtyEl = $('[data-qty]', line);
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      var up = $('[data-qty-up]', line), down = $('[data-qty-down]', line), rem = $('[data-line-remove]', line);
      if (up) up.addEventListener('click', function () { changeLine(key, qty + 1); });
      if (down) down.addEventListener('click', function () { changeLine(key, Math.max(0, qty - 1)); });
      if (rem) rem.addEventListener('click', function () { changeLine(key, 0); });
    });
  }
  bindCartLineEvents();

  /* ---------- product form ---------- */
  $$('.product-form').forEach(function (form) {
    var qtyInput = $('[data-qty-input]', form);
    var qtyDisp = $('[data-qty-display]', form);
    var qtyUp = $('[data-qty-up]', form), qtyDown = $('[data-qty-down]', form);
    var idInput = $('[data-variant-id]', form);
    var priceEl = $('[data-price]', form);
    var addBtn = $('[data-add-btn]', form);
    var addLabel = $('[data-add-label]', form);
    var variantsEl = $('[data-variant-json]', form);
    var variants = [];
    if (variantsEl) { try { variants = JSON.parse(variantsEl.textContent); } catch (e) {} }

    function getQty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    function setQty(n) { n = Math.max(1, n); if (qtyInput) qtyInput.value = n; if (qtyDisp) qtyDisp.textContent = n; }
    if (qtyUp) qtyUp.addEventListener('click', function () { setQty(getQty() + 1); });
    if (qtyDown) qtyDown.addEventListener('click', function () { setQty(getQty() - 1); });

    function selectedVariant() {
      if (!variants.length) return null;
      var opts = $$('[data-option-selector]:checked', form).map(function (i) { return i.value; });
      if (!opts.length) return variants[0];
      return variants.find(function (v) {
        return (v.options || []).every(function (o, idx) { return o === opts[idx]; });
      });
    }
    function syncVariant() {
      var v = selectedVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
    }
    $$('[data-option-selector]', form).forEach(function (i) { i.addEventListener('change', syncVariant); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var id = idInput ? idInput.value : null;
      if (!id) { form.submit(); return; }
      if (addLabel) addLabel.textContent = 'Adding…';
      postCart('/cart/add.js', { id: id, quantity: getQty() }).then(function (res) {
        if (res.status && res.status >= 400) { toast(res.description || 'Could not add'); if (addLabel) addLabel.textContent = 'Add to cart'; return; }
        if (addLabel) addLabel.textContent = 'Added ✓';
        toast('Added to cart');
        refreshCount();
        rerenderCart(res.sections);
        openCart();
        setTimeout(function () { if (addLabel) addLabel.textContent = 'Add to cart'; }, 1600);
      }).catch(function () { if (addLabel) addLabel.textContent = 'Add to cart'; });
    });
  });

  /* ---------- simple add buttons (bundles / cards) ---------- */
  $$('[data-add-id]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var id = btn.getAttribute('data-add-id');
      var orig = btn.textContent;
      postCart('/cart/add.js', { id: id, quantity: 1 }).then(function (res) {
        if (res.status && res.status >= 400) { toast(res.description || 'Could not add'); return; }
        btn.textContent = 'Added ✓';
        toast('Added to cart');
        refreshCount();
        rerenderCart(res.sections);
        openCart();
        setTimeout(function () { btn.textContent = orig; }, 1600);
      });
    });
  });

  /* ---------- product gallery ---------- */
  (function () {
    var gallery = $('[data-gallery]');
    var mainPh = $('.pdp-media .ph.main');
    if (!gallery || !mainPh) return;
    var mainImg = mainPh.querySelector('img.photo');
    $$('[data-thumb]', gallery).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-thumb');
        if (mainImg && src) { mainImg.src = src; mainImg.srcset = ''; }
        $$('[data-thumb]', gallery).forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  })();

  /* ---------- shop filter tabs (client-side) ---------- */
  (function () {
    var bar = $('[data-shop-tabs]');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var cat = btn.getAttribute('data-filter');
      $$('[data-filter]', bar).forEach(function (b) { b.classList.toggle('active', b === btn); });
      $$('[data-cat-group]').forEach(function (g) {
        g.classList.toggle('hide', cat !== 'all' && g.getAttribute('data-cat-group') !== cat);
      });
      $$('[data-bundle-cat]').forEach(function (b) {
        b.classList.toggle('hide', cat !== 'all' && b.getAttribute('data-bundle-cat') !== cat);
      });
    });
  })();

  /* ---------- The List filter tabs ---------- */
  (function () {
    var bar = $('[data-list-tabs]');
    if (!bar) return;
    bar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var cat = btn.getAttribute('data-filter');
      $$('[data-filter]', bar).forEach(function (b) { b.classList.toggle('active', b === btn); });
      $$('[data-list-card]').forEach(function (c) {
        c.classList.toggle('hide', cat !== 'all' && c.getAttribute('data-cat') !== cat);
      });
    });
  })();
})();
